import ReservedValue from './ReservedValue';

const keys: Array<{value: string; isDoubleWidth?: boolean; isSpaceBar?: boolean}> = [
    {value: '1'},
    {value: '2'},
    {value: '3'},
    {value: '4'},
    {value: '5'},
    {value: '6'},
    {value: '7'},
    {value: '8'},
    {value: '9'},
    {value: '0'},
    {value: ReservedValue.BACKSPACE, isDoubleWidth: true},
    {value: 'Q'},
    {value: 'W'},
    {value: 'E'},
    {value: 'R'},
    {value: 'T'},
    {value: 'Y'},
    {value: 'I'},
    {value: 'O'},
    {value: 'U'},
    {value: 'P'},
    {value: ReservedValue.DELETE_ALL, isDoubleWidth: true},
    {value: 'A'},
    {value: 'S'},
    {value: 'D'},
    {value: 'F'},
    {value: 'G'},
    {value: 'H'},
    {value: 'J'},
    {value: 'K'},
    {value: 'L'},
    {value: '-'},
    {value: ReservedValue.SWITCH_LANGUAGE_SET, isDoubleWidth: true},
    {value: 'Z'},
    {value: 'X'},
    {value: 'C'},
    {value: 'V'},
    {value: 'B'},
    {value: 'N'},
    {value: 'M'},
    {value: ','},
    {value: '.'},
    {value: '_'},
    {value: ReservedValue.SPECIAL_CHAR, isDoubleWidth: true},
    {value: ReservedValue.SPACE, isSpaceBar: true},
];

export default keys;
